// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownLinks_wrapper__0J4Au","link":"DropdownLinks_link__bhd48"};